import { PostTrackAccess } from './requests/analyticsRequests';

/**
 * Standalone helper — can be called anywhere outside React context.
 * Usage: trackAccess('ModuleId', 'Module Name', userId, 'Project Name');
 */
const trackAccess = async (moduleId, moduleName, userId, projects) => {
	if (!moduleId || !userId) return;

	try {
		await PostTrackAccess(moduleId, moduleName, userId, projects);
	} catch {
		// fail silently — tracking should never break the app
	}
};

export default trackAccess;